import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class AppManualService {
    configUrl = "";
    appUrl = "";
    accountApiUrl="";
    constructor(private http: HttpClient) {
      this.appUrl = environment.apiUrlNew + "Lead/TerrritoryLead/";
      this.configUrl = environment.configUrl;
      this.accountApiUrl = environment.apiUrlAccount + "Account/";
    }

    getConfigurationById(id) {
        return this.http.get<any>(this.configUrl + "Configuration/" + id)
            .toPromise()
            .then(res => res);
    }

    addConfiguration(obj) {
        return this.http.post<any>(this.configUrl + "Configuration", obj)
            .toPromise()
            .then(res => res);
    }

  getAccountColumnsSetings(templateId, objectId) {
    return this.http.get<any>(`${environment.configUrl}Configuration/ColumnSetting/${templateId}?objectId=${objectId}`)
  }
    getallTerritoryAccounts(templateId,pageNumber,pageSize,searchValue,loginUserId,organizationId, options?) {

        let url= '&SearchValue='+searchValue+'&loginUserId='+loginUserId+'&typeId='+templateId+'&stageId=0&pageNumber='+pageNumber+'&pageSize='+pageSize+'&filter=allaccounts&isActive=true&objectNameList=status&objectNameList=childaccounts&parentAccountId=0';

        if (options) {
            if(options?.fieldList){
                url =`${url}&fieldList=${options.fieldList}`;
            }
            if(options?.countryId!= undefined){
                url =`${url}&countryId=${options.countryId}`;
            }
            if(options?.parentterriId != undefined){
                url =`${url}&parentterriId=${options.parentterriId}`;
            }

            if(options?.sortBy){
                url = url + '&SortBy='+options.sortBy;
            }else{
                url = url + '&SortBy=CreatedDate';
            }

            if(options?.searchColumns){
                url = url + '&SearchColumns='+options.searchColumns;
            }else{
                url = url + '&SearchColumns=businessName';
            }

            if(options?.isAssending){
                url = url + '&IsAscending='+options.isAssending;
            }else{
                url = url + '&IsAscending=false';
            }
        }

        let urls = this.accountApiUrl + 'TerrritoryAccount?organizationId='+organizationId+ url;
        return this.http.get<any>(urls, {
          observe: 'response'
        })
          .toPromise()
          .then(res =>

          ({
            contacts: res.body,
            headers: JSON.parse(res.headers.get('x-pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
          })

          );
      }

    updateConfiguration(obj) {
        if (obj.id == 0) {
            return this.http.post<any>(this.configUrl + "Configuration", obj)
                .toPromise()
                .then(res => res);
        } else {

            return this.http.put<any>(this.configUrl + "Configuration", obj)
                .toPromise()
                .then(res => res);
        }
    }

    editConfiguration(obj) {
        return this.http.put<any>(this.configUrl + "Configuration/Edit", obj)
    }

    getAllTerritoryLeads(pageSize: number, pageNumber: number, companyID: number, userLoginID: number, searchValue?: string, seachFields?: string, options?, channelId?, objectNamesList?) {
        let url = this.appUrl + "?organizationId=" + companyID + "&userId=" +
            userLoginID + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize + '&isActive=true' + '&filter=allleads&isConvertedToAccount=false';

        if (channelId && channelId !== 0) {
            url = `${url}&typeId=${channelId}`;
        }

        if (options) {

            if(options.fieldList){
                url =`${url}&fieldList=${options.fieldList}`;
            }

            if (options.stageId != undefined) {
                url = `${url}&stageId=${options.stageId}`;
            }

            if (options.countryId != undefined) {
                url = `${url}&countryId=${options.countryId}`;
            }
            if (options.sort) {
                url = `${url}&SortBy=${options.sort.SortBy}&IsAscending=${options.sort.IsAscending}`;
            }

            if (options.moduleSearchValue) {
                url = `${url}&moduleSearchValue=${options.moduleSearchValue}`;
            }

            if (options.recentFilters) {
                url = `${url}&filters=${options.recentFilters}`;
            }

            if(options.parentterriId != undefined){
                url =`${url}&parentterriId=${options.parentterriId}`;
            }
        }

        if (!options || !options.sort) {
            url = `${url}&SortBy=createdDate&IsAscending=false`;
        }

        if (searchValue) {
            url = `${url}&SearchValue=${searchValue}`;
        }

        if (searchValue || (options && options.moduleSearchValue)) {
            url = `${url}&SearchColumns=${seachFields}`;
        }

        // if (objectNamesList && objectNamesList.length > 0) {
        //     objectNamesList.forEach(element => {
        //         url = `${url}&objectNameList=${element}`;
        //     });
        // }

        return this.http.get<any>(url, {
            headers: new HttpHeaders({
                "organizationId": companyID + '',
                "userId": userLoginID + ''
            }),
            observe: 'response'
        })
            .toPromise()
            .then(res =>
            ({
                leads: res.body,
                headers: JSON.parse(res.headers.get('X-Pagination')) //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            })
            );
    }


    getAllStages(companyID: number) {
        return this.http.get<any>(environment.apiUrlLead + 'LeadAPI/LeadStage?organizationId='+companyID);
    }

}
